import React from 'react';
import './TireDisposalToggle.css';

// On/off switch for a work order's or job's Tire Disposal. Put it inside a <label> with the
// field name so tapping the name toggles it too. boxClassName gives it the same box as the
// form's other inputs (e.g. 'workorderinputsdetails') so it lines up with them.
const TireDisposalToggle = ({ checked, onChange, boxClassName = '' }) => (
  <span className={`tire-toggle ${boxClassName}`}>
    <input
      type="checkbox"
      role="switch"
      className="tire-toggle-checkbox"
      name="tire_disposal"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span className="tire-toggle-track" aria-hidden="true">
      <span className="tire-toggle-knob" />
    </span>
    <span className="tire-toggle-text">{checked ? 'Yes' : 'No'}</span>
  </span>
);

export default TireDisposalToggle;
